angular.module('angus.services').service('priceCodeService', [
    '$http',
    function($http) {
        this.getBasePriceCodes = function(subscriberKey) {
            return $http.get(`api/subscriber/${subscriberKey}/base-price-codes`, {apiV2: true})
                .then(res => res.data);
        }
    }
])